import { useCallback, useEffect, useState } from "react";
import { projectWebSocketManager } from "../websocket";
import type { ProjectConnectionStatus } from "../websocket";

export function useActiveWebSocketConnection(projectId: string | undefined) {
  const [connectionStatus, setConnectionStatus] =
    useState<ProjectConnectionStatus>("disconnected");

  const connection = projectId
    ? projectWebSocketManager.setActiveProject(projectId)
    : null;

  const handleStatusChange = useCallback((status: ProjectConnectionStatus) => {
    setConnectionStatus(status);
  }, []);

  useEffect(() => {
    if (!connection) {
      return;
    }

    // Get the current status immediately
    const currentStatus = connection.getStatus();
    setConnectionStatus(currentStatus);

    connection.addStatusHandler(handleStatusChange);

    return () => {
      connection.removeStatusHandler(handleStatusChange);
    };
  }, [connection, handleStatusChange]);

  const connect = useCallback(async () => {
    if (!connection) {
      return;
    }

    try {
      await connection.connect();
    } catch (error) {
      // Connection errors will be handled through status changes
      // and by the messaging hook via the messageStore
    }
  }, [connection]);

  return {
    connection,
    status: connectionStatus,
    connect,
  };
}
